import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Euro, Users, Inbox, TrendingUp } from 'lucide-react'
import { cn } from '@/lib/utils'

interface MetricCardsProps {
  metrics: {
    total_sales: number
    active_users: number
    new_leads: number
    growth: number
  }
  visible: Record<string, boolean>
}

export function MetricCards({ metrics, visible }: MetricCardsProps) {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-PT', {
      style: 'currency',
      currency: 'EUR',
    }).format(value)
  }

  const items = [
    {
      key: 'total_sales',
      title: 'Vendas Totais',
      value: formatCurrency(metrics.total_sales),
      icon: Euro,
      color: 'text-slate-900',
    },
    {
      key: 'active_users',
      title: 'Utilizadores Ativos',
      value: metrics.active_users.toString(),
      icon: Users,
      color: 'text-blue-600',
    },
    {
      key: 'new_leads',
      title: 'Novos Leads',
      value: metrics.new_leads.toString(),
      icon: Inbox,
      color: 'text-yellow-600',
    },
    {
      key: 'growth',
      title: 'Crescimento',
      value: `+${metrics.growth}%`,
      icon: TrendingUp,
      color: 'text-green-600',
    },
  ]

  // Filter out invisible metrics
  const visibleItems = items.filter((item) => visible[item.key])

  if (visibleItems.length === 0) return null

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {visibleItems.map((item) => (
        <Card key={item.key}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-slate-500">
              {item.title}
            </CardTitle>
            <item.icon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className={cn('text-2xl font-bold', item.color)}>
              {item.value}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
